import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Store } from '@ngrx/store';
import * as HomebuildingActions from '@zayan-erp/stores';
import * as WarrantyActions from '@zayan-erp/stores';
import * as SalesActions from '@zayan-erp/stores';
import { UserAuthenticationService } from '../../../../../../libs/administration/src/lib/services/user-authentication.service';
import { AppState } from '../../store/app.reducers';

export const HomebuildingResolver: ResolveFn<void> = () => {
  const store = inject(Store<AppState>);
  store.dispatch(HomebuildingActions.loadProjects());
  store.dispatch(HomebuildingActions.loadLots());
  store.dispatch(HomebuildingActions.loadProductList());
  store.dispatch(HomebuildingActions.loadCategoryList());
  store.dispatch(HomebuildingActions.loadCities());
};
export const warrantyResolver: ResolveFn<void> = () => {
  const store = inject(Store<AppState>);
  store.dispatch(WarrantyActions.loadWarrantyTypes());
  store.dispatch(WarrantyActions.loadDeficiencyCode({ includingInActive: false }));
  store.dispatch(WarrantyActions.loadLocations({ includingInActive: false }));
};

export const salesResolver: ResolveFn<void> = () => {
  const store = inject(Store<AppState>);
  const userAuthService = inject(UserAuthenticationService);
  const user = userAuthService.getUser();

  // Get Sales module-specific role
  const salesModuleRole =
    user.userModuleRoles.find((x: any) => {
      const moduleMetadata = JSON.parse(x.module.metadata);
      return moduleMetadata.label === 'Sales';
    })?.role?.roleName || userAuthService.getUserRole();

  store.dispatch(HomebuildingActions.loadProjects());
  store.dispatch(SalesActions.loadSalesOffices());
  store.dispatch(SalesActions.loadSalesAgents());
  store.dispatch(HomebuildingActions.loadCities());
  store.dispatch(SalesActions.loadAgencies());
  store.dispatch(SalesActions.loadAgencyRealtors());
  store.dispatch(SalesActions.loadCountries());
};

export const executiveConsoleResolver: ResolveFn<void> = () => {
  const store = inject(Store<AppState>);
  store.dispatch(HomebuildingActions.loadProjects());
};
